import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} AxisMap
 * @prop {string} createdDate Date map was created
 * @prop {string} jobId Id of the currently operating job
 * @prop {string} status Current status
 * @prop {string} title Map title
 * @prop {string} type Map type
 */
export default PropTypes.shape({
  createdDate: PropTypes.string,
  jobId: PropTypes.string,
  status: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/axisMap.js